import React from "react";
import ApplicationsManagement from "./ApplicationsManagement";

const CandidateListView: React.FC = () => {
  return <ApplicationsManagement viewMode="list" />;
};

export default CandidateListView;
